/**
 * サイトの外へのリンク。**値はここだけに置く**（ヘッダー・フッター・トップから参照する）。
 */

/**
 * 公式の X アカウント（#41）。
 *
 * **ただのリンクとして出す。** X の埋め込み（ウィジェット・スクリプト）は読み込まない。
 * 読み込むと X の Cookie と追跡がサイトに入り、プライバシーポリシーの記述が変わる。
 * 問い合わせの窓口にはしない（問い合わせは `support.ts` のメールに一本化している）。
 */
export const X_ACCOUNT = 'drawgonapp';
export const X_URL = `https://x.com/${X_ACCOUNT}`;

/** 運営会社（App Store Connect のチーム weBaby G.K.）。 */
export const OPERATOR_URL = 'https://webaby.jp/';

/**
 * App Store のアプリのページ。**公開するまで `null`。**
 *
 * Apple の公式バッジは「App Store のアプリのページへのリンク」として使う決まりなので、
 * `null` の間はバッジを押せない形で出す（`AppStoreBadge`）。公開したら
 * `https://apps.apple.com/jp/app/id<Apple ID>` を入れる（Apple ID は App Store Connect のアプリ情報にある）。
 */
export const APP_STORE_URL: string | null = null;
